package br.com.texeratx.boardgametimeapp.ui.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Shapes
import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.theme.AppThemeMode

private val AppShapes = Shapes(
    extraSmall = RoundedCornerShape(10.dp),
    small = RoundedCornerShape(12.dp),
    medium = RoundedCornerShape(16.dp),
    large = RoundedCornerShape(20.dp),
    extraLarge = RoundedCornerShape(28.dp),
)

private val AppTypography = Typography()

@Composable
fun AppTheme(
    themeMode: AppThemeMode = AppThemeMode.DEFAULT,
    content: @Composable () -> Unit,
) {
    val colorScheme = when (themeMode) {
        AppThemeMode.DEFAULT -> DefaultAppColorScheme
        AppThemeMode.SHADOW -> ShadowAppColorScheme
    }

    val tokens = themeTokensFor(themeMode)

    CompositionLocalProvider(LocalAppThemeTokens provides tokens) {
        MaterialTheme(
            colorScheme = colorScheme,
            typography = AppTypography,
            shapes = AppShapes,
            content = content,
        )
    }
}
